export const getVideoCode = (videoUrl: string) => {
  try {
    const url = new URL(videoUrl);
    return url.searchParams.get('v') || null;
  } catch (err) {
    return null;
  }
};
